/*
jqajx-post.js
requires jQuery

usage:
Invokes callbacks on result.

return:
--
*/
export default {
	submit(the_url, data, successhandler, err_handler, content_type) {
        let errorhandler = null;
        let contentType = null;
        let data_str;
        if (err_handler && typeof err_handler === 'function') {
			errorhandler = err_handler;
		} else {
			errorhandler = function (err) {
				/*if the errorhandler is not passed then create a default handler*/
				if (err.status && err.status === 500) {
					console.warn('jqajx_post:26:try log in before sending request.', err);
				} else {
					console.error('jqajx_post:28:failure:', err);
				}
			};
		}
        /*To submit post request with data as queryParameters then specify content type as an argument*/
        contentType = (content_type || 'application/json; charset=UTF-8');

        /*Data shall be of type string*/
        if (typeof data === 'object') {
			data_str = JSON.stringify(data);
		} else if (typeof data === 'string') {
			data_str = data;
		} else {
			console.warn('jqajx_post:26: data has to be a string. Can not convert:', data);
		}

		jQuery.ajax({
			type: "POST",
			url: the_url,
			headers: {
				Accept: 'application/json, text/javascript, */*; q=0.01',
				'Content-Type': contentType,
				'Cache-Control': 'no-cache, no-store, must-revalidate',
				'Pragma': 'no-cache',
				'Expires': '0'
			},
			data: data_str,
			xhrFields: {
				withCredentials: true /*adds the cookie*/
			},
			crossDomain: false
		}).done(res => {
			successhandler(res);
		}).fail(err => {
			errorhandler(err);
		});
    }
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/common/lib/utils/jqajx-post.js